import {
  checkCurrentAuth,
  checkQueryAuthParams,
  completeAuthorization,
} from 'app/services/AuthService/handlers';
import { AuthenticationError, getErrorMessage } from 'shared/errors';
import { setAuthClientId } from 'shared/utils';
import { AuthConfigInterface } from './AuthConfigInterface';
import { isAuthCompletePage } from './config';

export type InitAuth = (authConfig: AuthConfigInterface) => Promise<void>;

export const initAuth: InitAuth = async authConfig => {
  setAuthClientId(authConfig.clientId);

  try {
    if (isAuthCompletePage()) return completeAuthorization(authConfig);

    await checkQueryAuthParams();

    return checkCurrentAuth(authConfig);
  } catch (error) {
    const errorMessage = getErrorMessage(error);

    if (errorMessage) throw new Error(errorMessage);

    throw new AuthenticationError('Catch error while initialize authorization!');
  }
};
